import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * Theme-aware Wide Watch wordmark (icon + lettering).
 *
 * The lettering is solid black in light mode and solid white in dark mode,
 * so we ship two SVGs and toggle them with the `.theme-dark` class on
 * <html> (set by lib/theme.ts). Pure CSS — no JS/theme-store dependency,
 * so it can't flash the wrong colour on first paint.
 */
export function Logo({ height = 28, className = '', alt = 'Wide Watch', }) {
    const common = `ww-logo ${className}`.trim();
    const style = { height, width: 'auto' };
    return (_jsxs(_Fragment, { children: [_jsx("img", { src: "/logo-full.svg", alt: alt, height: height, className: `${common} ww-logo--light`, style: style }), _jsx("img", { src: "/logo-full-dark.svg", alt: alt, height: height, className: `${common} ww-logo--dark`, style: style, "aria-hidden": true })] }));
}
